import React from 'react';
import { CustomInput, Label } from 'reactstrap';
import PropTypes from 'prop-types';

const ViewController = ({ view, handleView }) => {
    return (
        <div className="d-flex">
            <Label for="list-view" className="mr-3">
                <CustomInput
                    type="radio"
                    value='list'
                    onChange={handleView}
                    className="d-inline-block"
                    name="list"
                    id="list-view"
                    checked={view === 'list'}
                /> List view
            </Label>
            <Label for="table-view" className="mr-3">
                <CustomInput
                    type="radio"
                    value='table'
                    onChange={handleView}
                    className="d-inline-block"
                    name="table"
                    id="table-view"
                    checked={view === 'table'}
                /> Table view
            </Label>
        </div>
    );
};

ViewController.propTypes = {
    view: PropTypes.string.isRequired,
    handleView: PropTypes.func.isRequired
};

export default ViewController;